export function triggerCustomEvent(eventName: string, data?: any): void {
	const event = new CustomEvent(eventName, data);
	document.dispatchEvent(event);
}